import { render, staticRenderFns } from "./ProjectListPreview.vue?vue&type=template&id=478f8753&"
import script from "./ProjectListPreview.vue?vue&type=script&lang=js&"
export * from "./ProjectListPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports